<template>
  <div class="col-12">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome del costo"
        :value="value.name"
        :errorMsg="errorHash['name']"
        @input="updateField('name', $event)"
      />

      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Unità di misura"
        :value="value.measurementUnit"
        :errorMsg="errorHash['measurementUnit']"
        @input="updateField('measurementUnit', $event)"
      />

      <FormInputAmountWidget
        class="col-lg-4 col-sm-6"
        label="Quantità"
        :value="value.quantity"
        :min="1"
        :errorMsg="errorHash['quantity']"
        @input="updateField('quantity', $event)"
      />
    </div>

    <div class="row">
      <FormInputAmountWidget
        class="col-lg-4 col-sm-6"
        label="Costo unitario"
        :value="value.unitCost"
        :min="0"
        :errorMsg="errorHash['unitCost']"
        @input="updateField('unitCost', $event)"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Aliquota IVA"
        :value="value.vat"
        :errorMsg="errorHash['vat']"
        @input="updateField('vat', $event)"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Ritenuta fiscale"
        :value="value.ritenuta"
        :errorMsg="errorHash['ritenuta']"
        @input="updateField('ritenuta', $event)"
      />
    </div>
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Costo totale"
        v-model.number="total"
        notRequired
        disabled

      />
    </div>
    <div class="row">
      <div class="col-12">
        <FormInputPianoFatturazioneWidget
          :value="value.fatturazioni"
          :total="total"
          :scadenzarioPercentage="scadenzarioPercentage"
          :firstMonth="firstMonth"
          @input="updateField('fatturazioni', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  mixins: [validateMixin],
  components: {
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    FormInputPianoFatturazioneWidget: () => import('@/views/components/Operative/Form/Widgets/FormInputPianoFatturazioneWidget'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    firstMonth: {},
  },
  computed: {
    total () {
      return Math.ceil(parseInt(this.value.unitCost || 0) * parseInt(this.value.quantity || 0));
    },
    scadenzarioPercentage () {
      return (parseFloat(this.value?.vat || 0) || 0) - (parseFloat(this.value?.ritenuta || 0) || 0);
    },
  },
  methods: {
    emitValue (updates) {
      this.$emit('input', { ...this.value, ...(updates || {}) });
    },
    updateField (fieldName, newValue) {
      if (fieldName === 'name') {
        this.removeError('name');
        this.emitValue({ name: newValue });
      } else if (fieldName === 'fatturazioni') {
        this.removeError('fatturazioni');
        this.emitValue({ fatturazioni: newValue });
      } else if (fieldName === 'measurementUnit') {
        this.removeError('measurementUnit');
        this.emitValue({ measurementUnit: newValue });
      } else if (fieldName === 'unitCost') {
        this.removeError('unitCost');
        this.emitValue({ unitCost: parseInt(newValue || 0) || 0 });
      } else if (fieldName === 'vat') {
        this.removeError('vat');
        this.emitValue({ vat: parseInt(newValue || 0) || 0 });
      } else if (fieldName === 'ritenuta') {
        this.removeError('ritenuta');
        this.emitValue({ ritenuta: parseInt(newValue || 0) || 0 });
      } else if (fieldName === 'quantity') {
        this.removeError('quantity');
        this.emitValue({ quantity: parseInt(newValue || 0) || 0 });
      }
    },
  },
};

</script>
